import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsHistoricalBetsWidget" */ './SportsHistoricalBetsWidget'),
  modules: ['./SportsHistoricalBetsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
